import Button , {ButtonProps} from '@mui/material/Button'
import React from 'react'

export default function IseButton(props: ButtonProps) {
  return (
    <Button
        size={props.size === undefined ? 'small' : props.size }
        variant={props.variant === undefined ? 'outlined' : props.variant}
        {...props}
    />
  )
}
